import Grid from '../../components/Grid';
import Cirugias from '../../components/cirugias/admin_cirugias.vue';
import CirugiaService from '../../services/cirugia_service.js';
import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const cirugiaService = new CirugiaService();

let _this;
export default {
	name: 'cirugia',
	components: { Grid, Cirugias },
	data: function() {
		return {
			titulo: 'CIRUGIAS',
			actions: [{
				icon: 'search',
				name: 'Ver',
				actionBtn: this.verCirugia,
				buttonClass: 'btn btn-xs btn-light',
				hide: function() { return true }
			},{
				icon: 'pencil',
				name: 'Editar',
				actionBtn: this.editar,
				buttonClass: 'btn btn-xs btn-secondary',
				hide: function() { return true }
			},{
				icon: 'x',
				name: 'Desactivar',
				actionBtn: this.desactivar,
				buttonClass: 'btn btn-xs btn-danger',
				hide: function(item) { return item.activoProfesional == 'SI' }
			},{
				icon: 'bookmark-heart',
				name: 'Intraoperatorio',
				actionBtn: this.altaIntraoperatorio,
				buttonClass: 'btn btn-xs btn-primary',
				hide: function() { return true }
			},{
				icon: 'check-circle',
				name: 'Activar',
				actionBtn: this.activar,
				buttonClass: 'btn btn-xs btn-info',
				hide: function(item) { return item.activoProfesional == 'NO' }
			}],
			columns: [
				{key: 'idCirugia', value: 'Id'},
				{key: 'idInternacionCirugia', value: 'Internacion'},
				{key: 'nomyApPaciente', value: 'Paciente'},
				{key: 'dniPaciente', value: 'DNI'},
				{key: 'viaCirugia', value: 'Via'},
				{key: 'cirujanoCirugia', value: 'Cirujano'},
				{key: 'primerAyudanteCirugia', value: 'Primer Ayudante'},
				{key: 'segundoAyudanteCirugia', value: 'Segundo Ayudante'},
				{key: 'tieneIntraoperatorio', value: 'COMPLICACIONES IOP'},
				//{key: 'obraSocialPaciente', value: 'Obra Social'},
				//{key: 'sexoPaciente', value: 'Sexo'},
				//{key: 'nroHcPaciente', value: 'Historia Clinica'},
				//{key: 'camaInternacion', value: 'Cama'},
				{key: 'diagnosticoInternacion', value: 'Diagnostico'},
				{key: 'especialidadInternacion', value: 'Especialidad'},
			] 
		};
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		if(!loginService.hasPermission("listado", "cirugias")) {
			routeService.goToHome();
			return;
		}
		if(routeService.getParams().idPacienteInternacion != undefined) {
			if(!isNaN(routeService.getParams().idPacienteInternacion)) {
				this.search.idPacienteInternacion = routeService.getParams().idPacienteInternacion;
			}
		}
		if(routeService.getParams().idInternacionCirugia != undefined) {
			if(!isNaN(routeService.getParams().idInternacionCirugia)) {
				this.search.idInternacionCirugia = routeService.getParams().idInternacionCirugia;
			}
		}
	}, 
	methods: { 
		async desactivar(item) {
			try {
				if(!loginService.hasPermission("eliminar", "cirugias")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea desactivar el registro id: ' + item.idCirugia + '?');
				if(conf) {
					_this.submited = true;
					cirugiaService.remove({id: item.idCirugia}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoProfesional = 'NO';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro desactivado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		async activar(item) {
			try {
				if(!loginService.hasPermission("activar", "cirugias")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea activar el registro id: ' + item.idCirugia + '?');
				if(conf) {
					_this.submited = true;
					cirugiaService.activate({id: item.idCirugia}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoProfesional = 'SI';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro activado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		agregar: function () {
			if(!loginService.hasPermission("alta", "cirugias")) {
				routeService.goToHome();
				return;
			}
			if(_this.search.idInternacionCirugia) {
				//routeService.goTo('Cirugia', {idInternacionCirugia: _this.search.idInternacionCirugia}, true);
				routeService.goTo('cirugia');
			} else {
				routeService.goTo('cirugia');
			}
		},
		editar: function (item) {
			if(!loginService.hasPermission("editar", "cirugias")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('cirugia/' + item.idCirugia);
		},
		verCirugia: function (item) {
			if(!loginService.hasPermission("listado", "cirugias")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('ver-cirugia/' + item.idCirugia);
		},
		altaIntraoperatorio(item) {
			_this.modalCirugia = item;
			//this.$root.$emit('bv::show::modal', 'alta-internacion');
			//this.$bvModal.show('postoperatorio');
			if(!loginService.hasPermission("editar", "cirugia")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('intraoperatorio/' + item.idCirugia);
		},
		bindClass(item) {
			if(item.tieneIntraoperatorio == "SI")
				return "danger";
		},
		exportar() {
			this.search.exportTo = "excel";
			this.search.columns = [];
			for(let col of this.columns) {
				this.search.columns.push(col);
			}
			//this.search.columns.push({key: 'fechaAltaInternacion', value: 'Fecha de alta'});
			this.getData();
		},
		siguiente: function() {
			_this.search.page++;
			_this.getData();
		},
		anterior: function() {
			if(_this.search.page != 1)
				_this.search.page--;
			_this.getData();
		},
		changePage: function(page) {
			_this.search.page = page;
			_this.getData();
		},
		buscar() {
			_this.search.page = 1;
			_this.getData();
		}
	}
}

